import React from "react";
import {useTranslation} from "react-i18next";

import MDBox from "../../../materialDashboard/components/MDBox";
import MDTypography from "../../../materialDashboard/components/MDTypography";
import EditLatLngMap from "../../../components/maps/EditLatLngMap";
import MDInput from "../../../materialDashboard/components/MDInput";

import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import {aspects} from "./useStationForm";
import ProvinceAutocomplete from "../../../components/inputs/ProvinceAutocomplete";
import MunicipalityAutocomplete from "../../../components/inputs/MunicipalityAutocomplete";


const LocationSection = ({formik, onPositionChange, station}) => {
    const {t} = useTranslation(['stations', 'enums']);

    const handleProvinceChange = (provinceId) => {
        formik.setFieldValue('provinceId', provinceId  ?? null);
        formik.setFieldValue('municipalityId', null);
    }

    return <Stack spacing={1}>
        <MDBox>
            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                {t('stationForm.locationInfo')}
            </MDTypography>
        </MDBox>

        <EditLatLngMap lat={formik.values.lat}
                       lng={formik.values.lng}
                       onChange={onPositionChange}
                       style={{height: "400px"}}/>

        <MDInput name="lat"
                 label={t('stationForm.lat')}
                 value={formik.values.lat}
                 onChange={formik.handleChange}
                 error={formik.touched.lat && Boolean(formik.errors.lat)}
                 helperText={formik.touched.lat && formik.errors.lat}
                 variant="standard"
                 fullWidth
                 InputProps={{
                     endAdornment: <InputAdornment position="end">°</InputAdornment>,
                 }}
        />
        <MDInput name="lng"
                 label={t('stationForm.lng')}
                 value={formik.values.lng}
                 onChange={formik.handleChange}
                 error={formik.touched.lng && Boolean(formik.errors.lng)}
                 helperText={formik.touched.lng && formik.errors.lng}
                 variant="standard"
                 fullWidth
                 InputProps={{
                     endAdornment: <InputAdornment position="end">°</InputAdornment>,
                 }}
        />
        <MDTypography variant="caption" fontWeight="regular" color="text">
            {t('stationForm.epsgioLink')} <a
            href="https://epsg.io/transform#s_srs=23032&t_srs=4326" target="_blank"
            rel="noreferrer">epsg.io</a>
        </MDTypography>
        <MDInput name="elevation"
                 label={t('stationForm.elevation')}
                 value={formik.values.elevation}
                 onChange={formik.handleChange}
                 error={formik.touched.elevation && Boolean(formik.errors.elevation)}
                 helperText={formik.touched.elevation && formik.errors.elevation}
                 variant="standard"
                 fullWidth
                 InputProps={{
                     endAdornment: <InputAdornment position="end">
                         <Typography variant="caption">m</Typography>
                     </InputAdornment>,
                 }}
        />
        <MDInput name="slope"
                 label={t('stationForm.slope')}
                 value={formik.values.slope}
                 onChange={formik.handleChange}
                 error={formik.touched.slope && Boolean(formik.errors.slope)}
                 helperText={formik.touched.slope && formik.errors.slope}
                 variant="standard"
                 fullWidth
                 InputProps={{
                     endAdornment: <InputAdornment position="end">°</InputAdornment>,
                 }}
        />
        <MDInput name="aspect"
                 label={t('stationForm.aspect')}
                 value={formik.values.aspect}
                 onChange={formik.handleChange}
                 error={formik.touched.aspect && Boolean(formik.errors.aspect)}
                 helperText={formik.touched.aspect && formik.errors.aspect}
                 variant="standard"
                 fullWidth
                 select>
            <MenuItem value="">/</MenuItem>
            {
                aspects.map(option => (
                    <MenuItem key={option} value={option}>
                        {t('enums:aspect.' + option)}
                    </MenuItem>
                ))
            }
        </MDInput>
        <ProvinceAutocomplete name="provinceId"
                              value={formik.values.provinceId}
                              onChange={handleProvinceChange}
                              MDInputProps={{
                                  name: 'provinceId',
                                  label: t('stationForm.provinceId'),
                                  error: formik.touched.provinceId && Boolean(formik.errors.provinceId),
                                  helperText: formik.touched.provinceId && formik.errors.provinceId
                              }}
        />
        <MunicipalityAutocomplete name="municipalityId"
                                  provinceId={formik.values.provinceId}
                                  value={formik.values.municipalityId}
                                  onChange={(municipalityId) => formik.setFieldValue('municipalityId', municipalityId)}
                                  MDInputProps={{
                                      name: 'municipalityId',
                                      label: t('stationForm.municipalityId'),
                                      error: formik.touched.municipalityId && Boolean(formik.errors.municipalityId),
                                      helperText: formik.touched.municipalityId && formik.errors.municipalityId
                                  }}
        />
        <MDInput name="locationName"
                 label={t('stationForm.locationName')}
                 value={formik.values.locationName}
                 onChange={formik.handleChange}
                 error={formik.touched.locationName && Boolean(formik.errors.locationName)}
                 helperText={formik.touched.locationName && formik.errors.locationName}
                 variant="standard"
                 fullWidth
        />
        {
            station?.microZone?.code && <MDInput name="microZoneCode"
                                                 label={t('stationForm.microZoneCode')}
                                                 value={station?.microZone?.code ?? ""}
                                                 disabled
                                                 variant="standard"
                                                 fullWidth
            />
        }
    </Stack>
}

export default LocationSection;